import Assistentes from './services/Assistentes'
import Contrato from './services/Contrato'
import FontesPagadoras from './services/FontesPagadoras'
import Gestores from './services/Gestores'
import GruposRemuneracao from './services/GruposRemuneracao'
import LocaisExecucoes from './services/LocaisExecucoes'
import Operadoras from './services/Operadoras'
import PlanosOperadora from './services/PlanosOperadora'
import Prestadores from './services/Prestadores'
import Procedimentos from './services/Procedimentos'
import ProfissionaisExecutantes from './services/ProfissionaisExecutantes'
import TabelasReferencia from './services/TabelasReferencia'
import Calculadora from './services/Calculadora'

export default {
  Assistentes,
  Contrato,
  FontesPagadoras,
  Gestores,
  GruposRemuneracao,
  LocaisExecucoes,
  Operadoras,
  PlanosOperadora,
  Prestadores,
  Procedimentos,
  ProfissionaisExecutantes,
  TabelasReferencia,
  Calculadora
}
